import { IForm } from '@/components/types'
import { useSearchDateShortcut } from '@/hooks/useSearch'
const shortcuts = useSearchDateShortcut()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'channelId',
      type: 'select',
      label: '直播间',
      clearable: true,
      placeholder: '请选择直播间'
    },
    {
      field: 'accessTime',
      type: 'dateTimePicker',
      label: '访问时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    }
  ]
}
